// styles
import styled from "styled-components";
import { mobile } from "../../../styles/responsive";
// types
import { Trip } from "../../../types/common.types";
import removeTimezone from "../../../utils/removeTimezone";
import formatCLP from "../../../utils/formatCLP";

export default function TripsList({trips}: {trips: Trip[]}) {

    const rows = trips.flatMap(trip => trip.costs.map(c => ({
        date: trip.trip_date ? removeTimezone(trip.trip_date.toString()) : '',
        time: trip.trip_time,
        tour: trip.tour_id,
        passengers: trip.passengers ?? 0,
        name: c.name,
        value: c.value
    })))
    const totalPassengers = trips.reduce((acc, t) => acc + (t.passengers ?? 0), 0)
    const total = rows.reduce((acc, r) => acc + Number(r.value), 0)

    if (rows.length === 0) return null

    return (
        <Main>
            <div className="cost">
                <TableWrapper>
                    <Table>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Hora</th>
                                <th>Tour</th>
                                <th>Pax</th>
                                <th>Costo</th>
                                <th>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                rows.map((r, i) => (
                                    <tr key={i}>
                                        <td>{r.date}</td>
                                        <td>{r.time}</td>
                                        <td className="tour">{r.tour}</td>
                                        <td>{r.passengers}</td>
                                        <td>{r.name}</td>
                                        <td>{formatCLP(r.value)}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={2}>TOTAL</td>
                                <td>{trips.length} tours</td>
                                <td>{totalPassengers}</td>
                                <td></td>
                                <td>{formatCLP(total)}</td>
                            </tr>
                        </tfoot>
                    </Table>
                </TableWrapper>
            </div>
        </Main>
    )
}

const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 20px;
    ${mobile({
        width: '100%',
        padding: '0 10px'
    })}
    
    overflow: unset;
    
    .cost {
        background-color: ${props => props.theme.whiteBackground};
        border-radius: 10px;
        box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
        cursor: pointer;
        transition: all .3s ease;
        
        &:hover {
            box-shadow: 0 5px 10px ${props => props.theme.blackTransparent};
            transform: translateY(-3px);
        }
        
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 10px 10px 0 0;
            position: relative;
            height: 80px;
            background-color: ${props => props.theme.black};
            color: ${props => props.theme.white};
            
            .name {
                flex: 1;
                text-align: center;
            }
            
            .actions {
                height: 100%;
                display: flex;
                gap: 5px;
                padding: 5px;
            }
        }
    }
`

const TableWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: visible;
    ${mobile({
        overflowX: 'scroll',
        '-webkit-overflow-scrolling': 'touch'
    })}
`

const Table = styled.table`
    border-collapse: collapse;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 600px;
    
    ${mobile({
        minWidth: '300px'
    })}
    
    thead {
        width: 100%;
        background-color: #FFFFFF;
        position: sticky;
        top: 0;
        z-index: 10;
        
        tr {
            background-color: #f9fafb;
        }
        
        th {
            font-weight: 600;
            font-size: 13px;
            padding: 12px 8px;
            background-color: #f9fafb;
            border-bottom: 2px solid #e5e7eb;
            white-space: nowrap;
            text-align: center;
            color: #374151;
            
            ${mobile({
                fontSize: '12px',
                padding: '10px 6px'
            })}
        }
    }
    
    tbody {
        tr {
            transition: background-color 0.2s ease;
            
            &:hover {
                background-color: #f9fafb;
            }
        }
    }
    
    tfoot td {
        font-weight: 700;
        background-color: #f9fafb;
        border-top: 2px solid #e5e7eb;
    }

    td {
        text-align: center;
        padding: 12px 8px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        white-space: nowrap;
        color: #1f2937;

        &.tour {
            white-space: normal;
            text-align: left;
            min-width: 180px;
        }
        
        ${mobile({
            fontSize: '12px',
            padding: '10px 6px'
        })}
        
        
        span {
            display: inline-block;
            line-height: 1.4;
        }
    }
    
    tr {
        height: auto;
        width: 100%;
    }
`